import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { MdAdd } from "react-icons/md";
import { tidy_date } from "../../utils/helper";
import { duplicate_account, fetch_all_accounts } from "../../api/accountsAPI";
import DataTable from "../../components/ui/DataTable";
import notify from "../../utils/IANotification";

export default function AccountsPage() {
  const navigate = useNavigate();
  const { isAuthorised, userRole } = useFetchAuthorisation("user");
  let user_data = useFetchUserData();
  const [loading, setLoading] = useState(true)
  const [accountData, setAccountData] = useState([])

  const table_columns = [
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "Currencies",
      accessor: "currency",
      modifier: (data) => `SGD + ${data?.length} other currencies` || "N/A"
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (value, row) => `${tidy_date(row.updatedAt)}`
    },
    {
      header: "Date Submitted",
      accessor: "createdAt",
      modifier: (data) => tidy_date(data)
    }
  ]

  useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_accounts()
    if (error) return console.log("Error fetching accounts:", message)
    setAccountData(data)
    setLoading(false)
  }

  const duplicateAccount = async (account_id) => {
    const { data, error, message, status } = await duplicate_account(account_id)
    if (error) return notify({ type: "error", message: `Error duplicating account: ${message}` })
    notify({ type: "success", message: "Account duplicated successfully" })
    fetchAccounts()
  }


  return (
    <AdminLayout navSelected={"Accounts"}
      toolbar={
        <>
          <h1 className="text-2xl font-bold text-gray-900">
            Accounts
          </h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/accounts/details?account_id=new")
            }}
          >
            <MdAdd size={16} />
            New Account
          </button>
        </>
      }
    >
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={accountData}
            enableActions
            enablePagination
            accessorKey={'id'}
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <button className="hover:underline" onClick={() => duplicateAccount(row.id)}>
                    Duplicate
                  </button>
                  <button className="hover:underline" onClick={() => navigate(`/admin/accounts/details?account_id=${row.id}`)}>
                    Edit
                  </button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}